<template>
    <div class="tabs popups-tab noscroll layout-column">
        <div class="wrapper_header_sidebar">
            <div class="header_sidebar_wrpr">
	            <a @click="linkTo(null)" class="small-btn back_btn">
		            <inline-svg :src="require('@/assets/icons/back.svg')" />
	            </a>
                <h4 class="title_sidebar">Popups</h4>
	            <v-button class="new-popup" border :icon="require('@/assets/img/add_plus_icon.svg')"
	                      label="New popup" slim @click="openNewPopup" />
            </div>
        </div>

        <div id="tabs-content" class="scroll">
            <div class="tab-content">
	            <loading v-if="loading" />
	            <div v-else-if="!popups || popups.length===0">
		            <div class="no-popups">
			            <p class="flex-center">No popups were created yet!</p>
			            <p class="flex-center">The same popups can be re-used throughout all funnels and pages in your account.</p>
		            </div>
	            </div>
	            <div v-else class="popup-entry" :class="{'active': !!current_popup && current_popup.id===p.id}"
	                 v-for="p in popups" :key="'popup-'+p.id" @click="popupSelected(p)">
		            <div class="layout-column flex">
			            <span class="name">{{p.name}}</span>
			            <span class="path">#popup-{{ p.path }}</span>
		            </div>
		            <div class="layout-row flex-center flex-none">
			            <quick-actions-btn @menuClick="actionClicked($event, p)"
					            :items="[{label:'Edit'},
					            {label:'Duplicate',icon:require('@/assets/img/copy.svg')},'',
					            {label:'Delete',icon:require('@/assets/img/trash.svg')}]" />
		            </div>
	            </div>
<!--	            Don't put inside repeater it causes a current popup error. -->
	            <portal to="popup">
		            <delete-popup v-if="deletePopupOpen" :popup="deletePopup"
		                          @close="deletePopupOpen=false;deletePopup=null" @done="popupDeleted" />
	            </portal>
            </div>
        </div>

	    <div class="new-popup-panel" :class="{'open':newPopup}">
		    <div class="header">
			    <h2>New page popup
				    <a class="close-popup small-btn" @click="newPopup=false">
					    <inline-svg :src="require('@/assets/img/popup_close.svg')" />
				    </a>
			    </h2>
			    <span class="desc">
				    Your popup will be available to be used on all of your funnels and pages.
			    </span>
		    </div>
		    <div class="layout-column">
			    <div class="margin-t-25">
				    <input-field label="Name" v-model="newPopupData.name" placeholder="eg. My optin popup"
				    @input="nameChanged"/>
				    <span class="desc">
					    This is used to help you identify the popup <b>(visible to you only)</b>.
				    </span>
			    </div>
			    <div class="margin-t-25">
				    <input-field label="Path" v-model="newPopupData.path" prepend="#popup-" @input="pathChanged=true"
				                 placeholder="eg. my-optin-popup" />
				    <span class="desc">
					    This is will be used to open the popup from any page (link, button, or image click).<br>
					    Only use alpha-numeric values with a - or _.
				    </span>
			    </div>
		    </div>
		    <div class="flex"></div>
		    <div class="footer">
			    <v-button label="Create popup" slim :loading="saving" @click="createPopup"
			    :disabled="!newPopupData.name || !newPopupData.path"/>
			    <v-button label="Cancel" border slim @click="newPopup=false"/>
		    </div>
	    </div>

	    <div class="new-popup-panel" :class="{'open':dupPopupOpen}" v-if="dupPopup">
		    <div class="header">
			    <h2>Duplicate page popup [{{dupPopup.name}}]
				    <a class="close-popup small-btn" @click="dupPopupOpen=false">
					    <inline-svg :src="require('@/assets/img/popup_close.svg')" />
				    </a>
			    </h2>
			    <span class="desc">
				    Your duplicated popup will be available to be used on all of your funnels and pages.
			    </span>
		    </div>
		    <div class="layout-column">
			    <div class="margin-t-25">
				    <input-field label="New name" v-model="newPopupData.name" placeholder="eg. Privacy policy, Optin popup,...etc"
				                 @input="nameChanged"/>
				    <span class="desc">
					    This is used to help you identify the popup <b>(visible to you only)</b>.
				    </span>
			    </div>
			    <div class="margin-t-25">
				    <input-field label="New path" v-model="newPopupData.path" prepend="#popup-" @input="pathChanged=true"
				                 placeholder="eg. my-optin-popup" />
				    <span class="desc">
					    This is will be used to open the popup from any page (link, button, or image click).<br>
					    Only use alpha-numeric values with a - or _.
				    </span>
			    </div>
		    </div>
		    <div class="flex"></div>
		    <div class="footer">
			    <v-button label="Duplicate popup" slim :loading="saving" @click="duplicatePopup"
			              :disabled="!newPopupData.name || !newPopupData.path"/>
			    <v-button label="Cancel" border slim @click="dupPopupOpen=false"/>
		    </div>
	    </div>

    </div>
</template>

<script>
import colorPicker from "@/modules/page-editor/src/components/sidebar/sidebar-items/colorPicker.vue"
import imageUploader from "@/modules/page-editor/src/components/sidebar/sidebar-items/imageUploader.vue"
import TextInput from "@/modules/page-editor/src/components/sidebar/sidebar-items/TextInput.vue"
import marginPadding from "@/modules/page-editor/src/components/sidebar/sidebar-items/marginPadding.vue"
import Border from "@/modules/page-editor/src/components/sidebar/sidebar-items/Border.vue"
import selectItem from "@/modules/page-editor/src/components/sidebar/sidebar-items/selectItem.vue"
import InputNumber from "@/modules/page-editor/src/components/sidebar/sidebar-items/InputNumber.vue"
import ToggleInput from "@/modules/page-editor/src/components/sidebar/sidebar-items/ToggleInput.vue"
import ListItems from "@/modules/page-editor/src/components/sidebar/sidebar-items/ListItems.vue"
import Font from "@/modules/page-editor/src/components/sidebar/sidebar-items/Font.vue"
import ClickAction from "@/modules/page-editor/src/components/sidebar/sidebar-items/ClickAction.vue"
import TextAlign from "@/modules/page-editor/src/components/sidebar/sidebar-items/TextAlign.vue"
import FontStyling from "@/modules/page-editor/src/components/sidebar/sidebar-items/FontStyling.vue"
import FontPanel from "@/modules/page-editor/src/components/sidebar/sidebar-items/FontPanel.vue"
import SocialNetworks from "@/modules/page-editor/src/components/sidebar/sidebar-items/SocialNetworks.vue"
import PopupOpenBtn from "@/modules/page-editor/src/components/sidebar/sidebar-items/PopupOpenBtn.vue"
import MultiSelectItem from "@/modules/page-editor/src/components/sidebar/sidebar-items/MultiSelectItem.vue"
import debounceAction from "@/helpers/debounce"
import VButton from '@/components/base/v-button'
import InputField from '@/components/base/input-field'
import Loading from '@/components/Loading'
import QuickActionsBtn from '@/components/base/quick-actions-btn'
import {mapGetters} from "vuex";
import API from '@/api';
import DeletePopup from "@/modules/page-editor/src/components/sidebar/popups/delete-popup";

export default {
    name: 'PageProperties',
    components: {
	    DeletePopup,
	    Loading,
	    InputField,
	    QuickActionsBtn,
    	VButton,
        colorPicker,
        imageUploader,
        TextInput,
        marginPadding,
        Border,
        selectItem,
        InputNumber,
        ToggleInput,
        ListItems,
        Font,
        ClickAction,
        TextAlign,
        FontStyling,
        FontPanel,
        SocialNetworks,
        PopupOpenBtn,
        MultiSelectItem
    },
	mixins:[API],
    data() {
        return {
        	popups:[
		        {id:1,name:'popup name',path:'popup path'}
	        ],
        	newPopupData:{
        		name: '',
		        path:'',
		        html:'',
		        config: JSON.stringify({
			        children:[],
			        content:[],
			        rows:[],
			        attributes:{
				        basic:{
					        width:"medium",
					        padding: { top: 5, left: 5, right: 5, bottom: 5 },
					        font: {
						        fontStyling: { bold: false, italic: false, 'line-through': false, underline: false },
						        color: '#252A32',
						        fontFamily: '',
						        fontSize: 14,
					        },
					        border: {
						        radius: { bottomLeft: 6, bottomRight: 6, analytics: 6, topRight: 6 },
						        sides: { bottom: true, left: true, right: true, top: true },
						        color: 'transparent',
						        style: 'solid',
						        width: 0
					        }
				        },
				        advanced:{
					        id: '',
					        cssClasses: []
				        }
			        },
		        }),
	        },
	        saving: false,
	        loading: false,
        	pathChanged: false,
	        newPopup: false,
	        dupPopup: null,
	        dupPopupOpen: false,
          currentTab: 'basic',
	        deletePopupOpen: false,
	        deletePopup: null, // popup to delete
        }
    },
    computed: {
    	...mapGetters(['current_popup']),
        page() {
            return this.$store.state.page.page
        }
    },
    methods: {
	    actionClicked(e, popup){
		    let a = e.action;
		    if (a==='Delete') {
		    	this.deletePopup = popup;
		    	this.deletePopupOpen = true;
		    } else if (a==='Edit') {
			    this.popupSelected(popup);
			    this.$store.commit('PAGE_SET_TABID', {tab: 'popupProperties', id: null});
		    } else if (a==='Duplicate') {
		    	this.openDupPopup(popup)
		    }
	    },
	    popupDeleted(popup){
	    	try {
	    		this.deletePopup = null;
	    		this.deletePopupOpen = false;

	    		let index = this.popups.findIndex(x=>x.id===popup.id)
			    if (index>=0)
			    	this.popups.splice(index, 1)
		    } catch (e) {
	    		console.error(e)
		    }
	    },
	    async duplicatePopup(){
		    try {
			    this.saving = true;

			    if (!this.dupPopup) return;

			    let resp = await this.api.popups.clone(this.dupPopup.id, this.newPopupData)
			    if (resp.error) {
				    if (resp.info.status===409) this.$error(resp.info, resp.info.data)  // conflict
				    else throw resp;
			    } else {
				    this.dupPopupOpen = false;
				    this.dupPopup = null
				    this.popups.push(resp);
				    this.$info("","Popup created successfully")

				    this.popupSelected(resp);
			    }
		    } catch (e) {
			    this.$error(e)
		    } finally {
			    this.saving = false;
		    }
	    },
    	async createPopup(){
    		try {
    			this.saving = true;

    			let resp = await this.api.popups.create(this.newPopupData)
			    if (resp.error) {
			    	if (resp.info.status===409) this.$error(resp.info, resp.info.data)  // conflict
			    	else throw resp;
			    } else {
			    	this.newPopup = false;
			    	this.popups.push(resp);
			    	this.$info("","Popup created successfully")

				    this.popupSelected(resp);
			    }
		    } catch (e) {
			    this.$error(e)
		    } finally {
			    this.saving = false;
		    }
	    },
	    async load(){
		    try {
			    this.loading = true;
					this.popups = [];
			    let resp = await this.api.popups.getAll(true)
			    if (resp.error) {
			    	throw resp;
			    } else {
				    this.popups = resp;
			    }
		    } catch (e) {
			    this.$error(e)
		    } finally {
			    this.loading = false;
		    }
	    },
    	openNewPopup() {
    		this.newPopup = true;
    		this.pathChanged = false;
    		this.newPopupData.name = this.newPopupData.path = "";
	    },
	    openDupPopup(popup) {
		    this.dupPopup = popup;
		    this.dupPopupOpen = true;
		    this.pathChanged = false;
		    this.newPopupData.name = this.newPopupData.path = "";
	    },
	    nameChanged(ev){
	    	if (!this.pathChanged) {
	    		this.newPopupData.path = this.newPopupData.name.replace(/[\W_]+/g,"-").toLowerCase();
		    }
	    },
    	async popupSelected(popup) {
    		try {
    			popup.loading = true;

    			// prevents undefined errors while the popup content is being loaded.
			    popup.content = [];
			    popup.children = [];
			    popup.rows = [];

    			// unselect any tab, fixes a bug when selecting an element.
			    this.$store.commit('PAGE_SET_TABID', {tab: 'popupProperties', id: null});

			    this.$store.commit('PAGE_SET_POPUP', popup);

    			let resp = await this.api.popups.get(popup.id)
			    if (resp.error) {
			    	throw resp
			    }
			    resp.loading = false;

			    let c = JSON.parse(resp.config)
			    resp.children = c.children;
			    resp.content = c.content;
			    resp.rows = c.rows;
			    resp.attributes = c.attributes || {
				    basic:{
					    width:"medium",
							    padding: { top: 5, left: 5, right: 5, bottom: 5 },
					    font: {
						    fontStyling: { bold: false, italic: false, 'line-through': false, underline: false },
						    color: '#252A32',
								    fontFamily: '',
								    fontSize: 14,
					    },
					    border: {
						    radius: { bottomLeft: 6, bottomRight: 6, analytics: 6, topRight: 6 },
						    sides: { bottom: true, left: true, right: true, top: true },
						    color: 'transparent',
								    style: 'solid',
								    width: 0
					    }
				    },
				    advanced:{
					    id: '',
							    cssClasses: []
				    }
			    };

			    this.$store.commit('PAGE_SET_POPUP', resp);
		    } catch (e) {
			    console.error(e)

			    this.linkTo(null);
			    this.$store.commit('PAGE_SET_POPUP', null);
		    } finally {

		    }
    		// popup = {id:popup.id,name:'random name '+popup,html:'',config:{}, children:[], content:[], rows:[],}
	    },
        linkTo(tab) {
            this.$store.commit('PAGE_SET_TAB', tab)
        },
        debUpdate: debounceAction(function(ev, name, type) {
            this.onFieldUpdate(ev, name, type)
        }, 100),
        onFieldUpdate(ev, name, type) {
            // console.log({ev, name, type});
            this.$store.dispatch('PAGE_SET_PAGE_PROPS', {type, name, item: ev});
        }
    },
	mounted() {
    	this.load();
	}
}
</script>

<style lang="scss" scoped>
.popups-tab {
	position: relative;
	background: white;
	.no-popups {
		display: flex;
		flex-direction: column;
		min-height: 300px;
		justify-content: center;
		text-align: center;
		line-height: 150%;
	}
	.wrapper_header_sidebar {
		border-bottom: 1px solid #f4f5f8;
	}
	.new-popup {
		margin: 10px 0 10px auto;
	}
	.popup-entry {
		display: flex;
		flex-direction: row;
		padding: 10px 15px;
		font-size: 14px;
		cursor: pointer;
		border-bottom: 1px solid #f4f5f8;

		&:hover {
			background: #f4f5f8;
		}
		&.active {
			background: #dce9ff;
			color: #116dff;
			border-bottom: 1px solid #dce9ff;
			.path {
				color: #658cc9;
			}
		}
		.name {
			font-weight: 500;
		}
		.path {
			margin-top: 5px;
			color: $grey;
			font-size: 12px;
		}

		.button.delete {
			color: red !important;
			svg path {
				fill: red !important;
			}
		}
	}
}

.new-popup-panel {
	background: white;
	padding: 10px;
	width: 320px;
	left: 0px;
	visibility: hidden;
	top: 49px;
	position: fixed;
	border-right: 1px solid #e3e6f1;
	bottom: 0;
	box-shadow: 4px 4px 15px #0a0a0a21;
	transition: left .2s ease-in-out;
	z-index: -1;
	display: flex;
	flex-direction: column;

	.footer {
		border-top: 1px solid #e3e6f1;
		padding: 10px 15px;
		display: flex;
		flex-direction: row;
		bottom: 0;
		//position: absolute;
		background: white;
		.button {
			margin-right: 25px;
		}
	}
	&.open {
		left: 320px;
		visibility: visible;

	}
	.header {
		padding: 10px;
		border-bottom: 1px solid $light-grey;
		position: relative;
		.close-popup {
			position: absolute;
			top: 0;
			right: 0;
			svg {
				height: 16px;
				width: 16px;
			}
		}
		h2 {
			font-size: 18px;
			font-weight: 500;
		}
	}
	.desc {
		display: block;
		margin-top: 5px;
		font-size: 12px;
		color: $dark-grey;
		line-height: 130%;
	}
}

</style>
